<template>
  <div class="userinfo-container">
    <div class="title">账号信息</div>
    <el-form
      size="mini"
      label-width="100px"
      style="width:500px;margin:32px 0 0 96px"
    >
      <el-form-item label="用户名">
        <el-input disabled></el-input>
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input placeholder="请补充"></el-input>
      </el-form-item>
      <el-form-item label="单位名称">
        <el-input placeholder="请补充"></el-input>
      </el-form-item>
      <el-form-item label="工作岗位">
        <el-input placeholder="请补充"></el-input>
      </el-form-item>
      <el-form-item label="单位地址">
        <el-input placeholder="请补充"></el-input>
      </el-form-item>
      <el-form-item label="单位联系电话">
        <el-input placeholder="请补充"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.userinfo-container {
  min-height: 100vh;
}
.title {
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  border-bottom: 1px solid rgba(233, 233, 233, 1);
}
</style>
